import { create } from "zustand";

export const useAppStore = create((set) => ({
  activeFY: null,
  setActiveFY: (fy) => set({ activeFY: fy }),
  user: null,
  setUser: (user) => set({ user }),
}));
